/**
 * @title timeoutModal.js: Feature level module
 * @description The module used for displaying and handling the timeout modal
 * 
 */
class WorkerInterval {
  constructor(callback, interval) {
    const blob = new Blob([`setInterval(() => postMessage(0), ${interval});`]);
    const workerScript = URL.createObjectURL(blob);
    this.worker = new Worker(workerScript);
    this.worker.onmessage = callback;
  }

  stop() {
    this.worker.terminate();
  }
}

define(['utilityGlobal'], function(util){
	
	let timeoutModal = {
		/*
		 * timerCountdown is set to 5min and 5seconds
		 * the 15 second bufferTimer is needed to account 
		 * for page load + ajax delivery time
		 */
		state: null,
		timer: wcs.isPharmacy === 'true' ? 900000 : wcs.loginTimeOut, 
		timerCountdown: 300000,
		bufferTimer: 15000,
		backgroundModalSettings: null,
		lastActiveElement: null,
		timerInterval: null,
		timerSetTimeout: null,
		data: null,
		START_TIME: '05',
		/*
		 * constants defined for state only
		 */
		INITIALIZED: 'Initialized',
		DISPLAYED: 'Displayed',
		TIMEDOUT: 'Timed Out',
		CLEARING: 'Clearing',
		
		/*
		 * ALM 32035
		 * Create list hydrator
		 */
		createListInputValue: null,
		
		/*
		 * On init we check if user is signed in, 
		 * if not we do not init
		 */		
		init: () => {
			let timeUntilInit = timeoutModal.timer - timeoutModal.timerCountdown - timeoutModal.bufferTimer;
			timeoutModal.state = timeoutModal.INITIALIZED;
			if(COSTCO.util.isUserLoggedIn() && (wcs.isPharmacy === 'true' || !COSTCO.Header.isKmsiSession())){
				//start timeout modal timing
				timeoutModal.timerSetTimeout = setTimeout(()=>{
					console.log('loading timeout modal wcs.loginTimeout = ' + wcs.loginTimeOut);
					timeoutModal.displayTimeoutModal();
				},timeUntilInit);
			}
			return;
		},
		
		/*
		 * Finds any modal in the background and copies its settings,
		 * displays the timeout modal and scrolls to the appropriate section
		 */
		displayTimeoutModal: () => {
			if(COSTCO.dialog.isVisible()){
				timeoutModal.backgroundModalSettings = COSTCO.dialog.getSettings();
		    }
			COSTCO.dialog.initializeReturnFocusListener();
			timeoutModal.lastActiveElement = document.activeElement;
			timeoutModal.checkForCreateNewList();
			COSTCO.dialog.showAndHideModal(timeoutModal.loadTimeoutModalSettings());
			window.scrollTo(0,0);
		},
		
		/*
		 * Creates a 5min countdown timer 
		 * Modifies body text based on timeLeft 
		 * seconds and minutes are formatted to have 2 digits
		 * this function is killed in resetTimeoutModal()
		 */
		countdown: () => {
			timeoutModal.state = timeoutModal.DISPLAYED;
			let timeLeft = new Date(timeoutModal.timerCountdown);
			let textBody = messages.TIMEOUT_MODAL_BODY;
			$('#timeout-modal-countdown-text').html(textBody.replace('{0}', timeoutModal.START_TIME).replace('{1}', '00'));
			timeoutModal.timerInterval = new WorkerInterval(()=>{
				if(timeLeft.getSeconds() === 0 && timeLeft.getMinutes() === 0){
					timeoutModal.state = timeoutModal.TIMEDOUT;
					timeoutModal.resetTimeoutModal();
					COSTCO.dialog.close();
					const isAddressBookDisplayView = document.location.pathname === '/AddressBookDisplayView'
					if (isAddressBookDisplayView) {
						document.location.href = 'Logoff?URL=ReLogonFormView';
					} else if(wcs.isPharmacy === 'true') {
						document.location.href = 'Logoff?usrClk=true';
					}
					return;
				} 
				let seconds = timeLeft.getSeconds() < 10 ? '0' + timeLeft.getSeconds() : timeLeft.getSeconds();
				let minutes = timeLeft.getMinutes() < 10 ? '0' + timeLeft.getMinutes() : timeLeft.getMinutes();
				let textBodyCopy = textBody.replace('{0}', minutes).replace('{1}', seconds);
				$('#timeout-modal-countdown-text').html(textBodyCopy);
				timeLeft = new Date(timeLeft-1000);
			},1000);
		},
		
		/*
		 * Makes an ajax call to /AjaxRefreshUserSession
		 * on success it resets and re-inits the modal sequence
		 * on failure it resets and closes the modal
		 */
		ajaxRefreshUserSession: function(){
			$.ajax({
				url: (wcs.isPharmacy === 'true') ? '/AjaxRefreshUserSession?isPharmacy=true' : '/AjaxRefreshUserSession',
				success: function(data){
					timeoutModal.data = JSON.parse(data);
					if(timeoutModal.data.status === '1'){
						console.log("success refreeshing session");
						timeoutModal.timerInterval.stop();
					} else {
						console.log('error refreshing session');
					}
				},
				error: function(data){
					console.log('error making ajax call');
					COSTCO.dialog.close();
				}
			});
		},
		
		/*
		 * set of modal options - see costcodialog.js for root 
		 * 2nd onclick event listener is for the close button 
		 * necessary to setTimeout and call the function as is 
		 * because order of execution loses the other function call
		 */
		loadTimeoutModalSettings: function(){
			var modalOptions = {
				title: messages.TIMEOUT_MODAL_HEADER,
				body: COSTCO.util.tmpl('tmpl_timeout_modal'),
				hideFooter: true,
				preventClose: true,
				onshown: function(e){
					timeoutModal.countdown();
					e.preventDefault();
					$('#timeout-submit').focus();
					$('#timeout-submit').on('click', function(e){
						e.preventDefault();
						timeoutModal.modalOnclick();
					});
					$('#timeout-cancel').on('click', function(e){
						e.preventDefault();
						COSTCO.dialog.close();
					});
					$('#timeout-modal').parent().prev().find('.co-close').on('click', function(e){
						COSTCO.dialog.close();
						e.preventDefault();
						$(this).unbind();
					});
				}, 
				close: function(){
					COSTCO.dialog.close();
				}
			};
			return modalOptions;
		},
		
		/*
		 * general handler for closing/refreshing the timeout modal
		 * this is called on click/spacebar for any button of the timeout modal
		 */
		modalOnclick: function(){
			timeoutModal.ajaxRefreshUserSession();
			if(COSTCO.dialog.isVisible()){
				timeoutModal.backgroundModalSettings === null ? 
						COSTCO.dialog.close() 
						: COSTCO.dialog.showAndHideModal(timeoutModal.backgroundModalSettings);
				$(timeoutModal.lastActiveElement).focus();
			}
	   		timeoutModal.resetTimeoutModal();
	   		if(timeoutModal.state !== timeoutModal.TIMEDOUT){
	   		new COSTCO.timeoutModal.init();
	   		}
		},
		
		/*
		 * resets all values and clears state 
		 * clears intervals and timeouts 
		 */
		resetTimeoutModal: function() {
			if(timeoutModal.state !== timeoutModal.TIMEDOUT){
				timeoutModal.state = timeoutModal.CLEARING;
			}
			timeoutModal.backgroundModalSettings = null;
			clearInterval(timeoutModal.timerInterval);
			clearTimeout(timeoutModal.timerSetTimeout);
			if(timeoutModal.state === timeoutModal.TIMEDOUT){
				console.log("Session timed out");
			} else {
				console.log("TIMEOUT MODAL DONE CLEARING");
			}
		},
		
		checkForCreateNewList: function(){
			if(timeoutModal.backgroundModalSettings !== null 
					&& timeoutModal.backgroundModalSettings.primary === messages.MA_CREATELIST){
				timeoutModal.backgroundModalSettings.onshown = function(){
					$('#listidname').val(COSTCO.timeoutModal.createListInputValue);
					$('#listidname').focus();
				}
				let listIdNameVal = $('#listidname').val();
				timeoutModal.createListInputValue = listIdNameVal;
			} 
		}
	}
	
	if (typeof window.COSTCO == 'undefined'){
	    window.COSTCO = new Object();
    }
	/*
	 * exposing the file to global
	 * use COSTCO.timeoutModal.xxx to check
	 * any constants defined at the top
	 */
	window.COSTCO.timeoutModal = timeoutModal;
	    return timeoutModal;
})


// WEBPACK FOOTER //
// ./js/utility/timeoutModal.js